import React from 'react';
import { useTranslation } from 'react-i18next';
import { Accordion, Panel, List, ListItem, Section, SectionTitle, Typography } from 'common/components';
import { analyticsUtils } from 'utils/analytics-utils';
import { CEILINGS_ELEMENT_BLOCK } from '../../ceilings-constants';
import {
  questionAccordion,
  questionDescriptionList,
  questionDescriptionSubList,
  questionDescriptionText,
  questionSectionTitle,
} from './ceilings-question-section-styles';

export const CeilingsQuestionSection = () => {
  const { t } = useTranslation();
  /**
   * Обработчик нажатия на колапс панели
   */
  const handlePanelClick = (question: string) => (_: string, isOpen: boolean) => {
    if (!isOpen) {
      analyticsUtils.clickButtonEvent(
        CEILINGS_ELEMENT_BLOCK,
        question.slice(0, 100),
        'Часто задаваемые вопросы'
      );
    }
  };

  return (
    <Section itemScope itemType="https://schema.org/FAQPage">
      <SectionTitle className={questionSectionTitle} variant="h2">
        {t('question-section.title')}
      </SectionTitle>

      <Accordion className={questionAccordion}>
        <Panel name="cost" onClick={handlePanelClick(t('question-section.cost.title'))} title={t('question-section.cost.title')}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <div itemProp="text">
              <Typography className={questionDescriptionText} variant="s" size="body_long">
                {t('question-section.cost.answer1')}
              </Typography>
              <ol className={questionDescriptionList}>
                <ListItem variant="s" text={t('question-section.cost.answer2') || ''} />
                <ListItem
                  text={t('question-section.cost.answer3') || ''}
                  variant="s"
                />
                <ListItem>
                  <Typography variant="s" size="body_long">
                  {t('question-section.cost.answer4')}
                  </Typography>
                  <List className={questionDescriptionSubList} listStyle="disc">
                    <ListItem text={t('question-section.cost.answer5') || ''} variant="s" />
                    <ListItem text={t('question-section.cost.answer6') || ''} variant="s" />
                    <ListItem
                      text={t('question-section.cost.answer7') || ''}
                      variant="s"
                    />
                    <ListItem
                      text={t('question-section.cost.answer8') || ''}
                      variant="s"
                    />
                  </List>
                </ListItem>
              </ol>
            </div>
          </div>
        </Panel>
        <Panel
          name="whenToStretch"
          onClick={handlePanelClick(t('question-section.stretch.title'))}
          title={t('question-section.stretch.title')}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <div itemProp="text">
              <Typography className={questionDescriptionText} variant="s" size="body_long">
                {t('question-section.stretch.answer1')}
              </Typography>
              <ol className={questionDescriptionList}>
                <ListItem
                  text={t('question-section.stretch.answer2') || ''}
                  variant="s"
                />
                <ListItem
                  text={t('question-section.stretch.answer3') || ''}
                  variant="s"
                />
              </ol>
            </div>
          </div>
        </Panel>
        <Panel
          name="wherePossible"
          onClick={handlePanelClick(t('question-section.possible.title'))}
          title={t('question-section.possible.title')}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <Typography className={questionDescriptionText} itemProp="text" variant="s" size="body_long">
              {t('question-section.possible.answer')}
            </Typography>
          </div>
        </Panel>
      </Accordion>
    </Section>
  );
};
